// extracted by mini-css-extract-plugin
export default {"wrapperModal":"Modal_wrapperModal__gUUMK","black":"Modal_black__kWgq7","wallet":"Modal_wallet__DInN-"};